import React from 'react';
import {EvoIndustry} from "../../widgets/evoIndustry";
import {Partners} from "../../widgets/partners";
import {Announcements} from "../../widgets/announcements";
import {Archive} from "../../widgets/archive";
import {Subscription} from "../../widgets/subscription";

export const Main = () => {
  return (
    <>
      <Announcements />
      <EvoIndustry />
      <Archive />
      <Partners />
      <Subscription />
    </>
  );
}